import { styled } from '@mui/material/styles';
import { Card, Stack, Grid, TextField } from '@mui/material';
import { Form, Formik, FormikProps } from 'formik';
import { LoadingButton } from '@mui/lab';
import * as Yup from 'yup';

const CardStyle = styled(Card)(({ }) => ({
    width: '100%',
    padding: 24
}));

export interface FormValues {
    submitForm: any,
    initialValues: any
}

export default function CloseProjectForm({ submitForm, initialValues }: FormValues) {

    const SchemaCategoryForm = Yup.object().shape({
        poNumber: Yup.string().required('PO Number is required'),
    });

    return (
        <CardStyle>
            <Formik
                onSubmit={(values, { setSubmitting }) => {
                    submitForm(values, setSubmitting);
                }}
                validateOnBlur={false}
                validateOnChange={true}
                enableReinitialize={true}
                validationSchema={SchemaCategoryForm}
                initialValues={{
                    projectCode: initialValues.dialogProjectClose,
                    poNumber: '',
                }}
            >
                {(formikProps: FormikProps<any>) => (
                    <Form autoComplete="off" noValidate onSubmit={formikProps.handleSubmit}>
                        <Stack spacing={3}>
                            <Grid
                                container
                                spacing={3}
                            >
                                <Grid
                                    item
                                    md={12}
                                    xs={12}
                                >
                                    <TextField
                                        error={Boolean(formikProps.touched.poNumber && formikProps.errors.poNumber)}
                                        fullWidth
                                        helperText={formikProps.touched.poNumber && formikProps.errors.poNumber}
                                        label="PO Number"
                                        {...formikProps.getFieldProps('poNumber')}
                                        variant="standard"
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <LoadingButton
                                    size="medium"
                                    type="submit"
                                    variant="contained"
                                    disabled={!formikProps.values.poNumber}
                                    loading={formikProps.isSubmitting}
                                >
                                    {'Close Project'}
                                </LoadingButton>
                            </Grid>
                        </Stack>
                    </Form>
                )}
            </Formik>
        </CardStyle>
    );
}
